/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { LinkEditContext } from "cms/links/link-selector/context/edit";
import TabPanel from "./tab-panel";
import DebugJSON from "components/debug_json";

const LinkEditPlacementsPanel = () => {

    const {
        // hasLink,
        selectedLink,
        selectedTab,
    } = useContext(LinkEditContext);

    return (
        <Fragment>

            <TabPanel
                value={selectedTab}
                index={1}
            >
                {/*{hasLink && (*/}
                {selectedLink && (
                    <div style={{
                        // border: '1px solid lime',
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                    >
                        <div
                            style={{
                                // flex: '0 1 80px',
                                // justifySelf: 'center',
                                // lineHeight: '80px',
                                // height: '80px',
                                // display: 'flex',
                                // flexDirection: 'column',
                                // justifyContent: 'center',
                                // alignItems: 'center',
                                // border: '1px solid #E4E4E4',
                                padding: "24px",
                                overflow: "auto",
                                height: "100%"
                            }}
                        >

                            {/*This image is used on 1 page*/}
                            <div style={{ fontWeight: "700" }}>Placements is not implemented at this time.</div>
                            <div>Text: {selectedLink.text}</div>
                            <div>Url: {selectedLink.url}</div>
                            <div>Type: {selectedLink.link_type}</div>
                            <div>Path: {selectedLink.path}</div>
                            <div>Webpage: {selectedLink.webpage}</div>

                            <DebugJSON name='Show link state' json={selectedLink} />

                        </div>

                        {/*<div style={{*/}
                        {/*    flex: '1 1 auto',*/}
                        {/*    marginTop: '8px',*/}
                        {/*    marginBottom: '8px',*/}
                        {/*    border: '1px solid #E4E4E4',*/}
                        {/*    // borderRadius: '8px',*/}
                        {/*    width: '100%',*/}
                        {/*    // height: '100%',*/}
                        {/*    minHeight: '175px',*/}
                        {/*    display: 'block',*/}
                        {/*    overflowY: 'auto',*/}
                        {/*    // height: calc(100vh - 340px);*/}
                        {/*    // flex: '0 0 auto', border: '1px solid red',*/}
                        {/*}}>*/}
                        {/*    <div style={{*/}
                        {/*        width: '100%',*/}
                        {/*        // height: 'calc(100vh - 340px)'*/}
                        {/*        height: '100%',*/}
                        {/*        // height: '350px',*/}
                        {/*        // height: '415px',*/}
                        {/*        display: 'flex',*/}
                        {/*        flexDirection: 'column',*/}
                        {/*        justifyContent: 'center',*/}
                        {/*        alignItems: 'center',*/}
                        {/*    }}>*/}
                        {/*        <div style={{fontSize: '10px'}}>*/}
                        {/*            <pre>*/}
                        {/*                {JSON.stringify(selectedLink, null, 2)}*/}
                        {/*            </pre>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*    <div style={{*/}
                        {/*        width: '100%',*/}
                        {/*        // height: 'calc(100vh - 340px)'*/}
                        {/*        // height: '1600px'*/}
                        {/*    }}>*/}
                        {/*        <p>Title | Location table</p>*/}
                        {/*        <p>1031-1045 Ridgewood Drive | /building-and-development/development</p>*/}
                        {/*        <p>1031-1045 Ridgewood Drive | /building-and-development/development</p>*/}
                        {/*        <p>1031-1045 Ridgewood Drive | /building-and-development/development</p>*/}
                        {/*        <p>1031-1045 Ridgewood Drive | /building-and-development/development</p>*/}
                        {/*        <p>1031-1045 Ridgewood Drive | /building-and-development/development</p>*/}
                        {/*        <p>1031-1045 Ridgewood Drive | /building-and-development/development</p>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/*<div style={{*/}
                        {/*    flex: '0 1 80px',*/}
                        {/*    lineHeight: '80px',*/}
                        {/*    height: '80px',*/}
                        {/*    // border: '1px solid #E4E4E4',*/}
                        {/*    display: 'flex',*/}
                        {/*    justifyContent: 'center',*/}
                        {/*    alignItems: 'center',*/}
                        {/*}}>*/}
                        {/*    /!*<div>Pagination Controls</div>*!/*/}
                        {/*</div>*/}

                    </div>
                )}
            </TabPanel>

        </Fragment>
    );
};

export { LinkEditPlacementsPanel };
